import React from "react";
import Box from "@mui/material/Box";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useTranslation } from "react-i18next";

const HelpDetails = ({ question, answer, goBackHandler }) => {
  const { t, i18n } = useTranslation();
  return (
    <Box>
      <Box
        onClick={goBackHandler}
        sx={{ cursor: "pointer", pb: 2, display: "flex", alignItems: "center" }}
      >
        <KeyboardBackspaceIcon />
        &nbsp;<span className="link">{t("Go back")}</span>
      </Box>
      <Box
        sx={{
          fontSize: "17px",
          fontWeight: "bold",
          pb: 2,
          pt: 3,
          color: "#455a64",
        }}
      >
        <Box
          sx={{ lineHeight: "190%" }}
          dangerouslySetInnerHTML={{ __html: question }}
        />
      </Box>
      <div>
        <Box
          sx={{ lineHeight: "190%" }}
          dangerouslySetInnerHTML={{ __html: answer }}
        />
      </div>
    </Box>
  );
};

export default HelpDetails;
